<template>
    <vs-table class="freeze_row row1" :data="results" :hoverFlat="true" stripe>
        <template slot="thead">
            <vs-th style="min-width: 70px;"></vs-th>
            <vs-th>ID</vs-th>
            <vs-th style="min-width: 120px">Issue Date</vs-th>
            <vs-th style="min-width: 120px">Date Created</vs-th>
            <vs-th style="min-width: 120px;">Closed Status</vs-th>
            <vs-th style="min-width: 120px;">Closed On</vs-th>
            <vs-th style="min-width: 120px;">Reporter Name</vs-th>
            <vs-th>Side</vs-th>
            <vs-th style="min-width: 110px">Chainage From</vs-th>
            <vs-th style="min-width: 110px">Chainage To</vs-th>
            <vs-th style="min-width: 100px">Width (m)</vs-th>
            <vs-th style="min-width: 100px">Length (m)</vs-th>
            <vs-th style="min-width: 100px">Area (m^2)</vs-th>
            <vs-th style="min-width: 100px">Remarks</vs-th>
            <vs-th style="min-width: 100px" v-if="report_mode">Type Of Road</vs-th>
            <vs-th class="text-right" v-if="!report_mode">Actions</vs-th>
            <vs-th style="min-width: 120px">Approval Status</vs-th>
            <vs-th style="min-width: 120px;" v-if="!report_mode">Delete Action</vs-th>
        </template>
        <vs-tr v-for="(item, index) in results" :key="index">
            <vs-td>
                <vs-checkbox v-model="rows" name="rows" :vs-value="index" :disabled="item.status != 'p' || !(showReview)" />
            </vs-td>
            <vs-td>
                <template v-if="item.sync_mode == 'offline'">
                    <div class="flex" style="justify-content: center; align-items: center;">
                        {{ item.data.id }}&ensp;
                        <vx-tooltip text= "Offline Issue" color="primary">
                            <font-awesome-icon class="text-primary" :icon="offlineIcon"/>
                        </vx-tooltip> 
                    </div>
                </template>
                <template v-else>
                    {{ item.data.id }}
                </template>
            </vs-td>
            <vs-td> <FormatText :text="item.date" format="date" /> </vs-td>
            <vs-td> <FormatText :text="item.created_on" format="datetime" /> </vs-td>
            <vs-td>
                <div :class="{'text-warning': item.closed_status =='p', 'text-danger': item.closed_status =='r', 'text-success': item.closed_status =='c', 'font-bold': true}">
                    <FormatText :text="item.closed_status" format="select" :kwargs="[{label: 'Pending', value: 'p'},{label: 'Rejected', value: 'r'},{label: 'Completed', value: 'c'}]"  />
                </div>
            </vs-td>
            <vs-td>
                <template v-if="item.closed_on">
                    <FormatText :text="item.closed_on" format="datetime" />
                </template>
                <template v-else>
                    -
                </template>
            </vs-td>
            <vs-td>
                {{ item.added_by.first_name }} {{ item.added_by.last_name }}
            </vs-td>
            <vs-td> <FormatText :text="item.data.side" format="select" :kwargs="[{label: 'LHS', value: 'lhs'}, {label: 'RHS', value: 'rhs'}, {label: 'Junctions', value: 'junctions'}, {label: 'Median', value: 'median'}]" /> </vs-td>
            <vs-td> {{ item.data.chainage_from }} </vs-td>
            <vs-td> {{ item.data.chainage_to }} </vs-td>
            <vs-td> {{ item.data.width }} </vs-td>
            <vs-td> {{ item.data.length }} </vs-td>
            <vs-td> {{ item.data.area }} </vs-td>
            <vs-td> {{ item.data.remarks }} </vs-td>
            <vs-td v-if="report_mode"> {{ item.data.type_of_road ? item.data.type_of_road.name : '-'  }} </vs-td>
            <vs-td v-if="!report_mode" id="actions">
                <template v-if="item.status == 'r' && editIssue(item)">
                    <router-link :to="{name: 'dpr-entry-edit', params: {issue_type: item.issue_type, module_key: item.module_key, dpr_entry_id: item.id}}">
                        <vs-button type="filled" size="small" color="primary">Edit</vs-button>
                    </router-link>
                </template>
                <router-link :to="{name: 'dpr-entry-view', params: {issue_type: item.issue_type, module_key: item.module_key, dpr_entry_id: item.id}}" v-else>
                    <vs-button type="filled" size="small" color="primary">View</vs-button>
                </router-link>
                <template v-if="item.status == 'p' && showReview">
                    <vs-button class="ml-2" type="filled" size="small" color="success" @click="$emit('approve', index)" :disabled="disabled">Approve</vs-button>
                    <vs-button class="ml-2" type="filled" size="small" color="danger" @click="$emit('reject', index)" :disabled="disabled">Reject</vs-button>
                </template>
            </vs-td>
            <vs-td>
                <template>
                    <div v-if="item.status == 'u'" class="text-warning font-bold">
                        Updating
                    </div>
                    <div v-if="item.status == 'p'" class="text-warning font-bold">
                        Pending
                    </div>
                    <div v-else-if="item.status == 'r'" class="text-danger font-bold">
                        Rejected
                    </div>
                    <div v-else-if="item.status == 'a'" class="text-success font-bold">
                        Approved
                    </div>
                </template>
            </vs-td>
            <vs-td v-if="!report_mode">
                <template v-if="delete_permission(item)">
                    <vx-tooltip text= "Delete" color="danger">
                        <vs-button @click="$emit('do_delete', item.id)" size="small" type="flat">
                            <font-awesome-icon size="2x" class="text-danger" :icon="deleteIcon"/>
                        </vs-button>
                    </vx-tooltip>
                </template>
                <template v-else>
                    -
                </template>
            </vs-td>
        </vs-tr>
    </vs-table>
</template>

<script>
import { faTrash, faBolt } from '@fortawesome/free-solid-svg-icons'

export default {
    props: {
        results: {
            type: Array,
            required: true
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false  
        },
        report_mode: {
            type: Boolean,
            required: false
        },
        selected_rows: {
            type: Array,
            require: true
        },
        delete_permission: {
            type: Function,
            require: true
        },
        showReview: {
            type: Boolean,
            required: true,
        },
        editIssue: {
            type: Function,
            require: true
        }
    },
    data() {
        return {
            rows: this.selected_rows,
        }
    },
    computed: {
        deleteIcon: () => faTrash,
        offlineIcon: () => faBolt,
    },
    watch: {
        rows (newV) { 
            this.$emit('selectedRows', newV) 
        },
        selected_rows(newV) {
            this.rows = newV
        }
    },
}
</script>

<style>
#actions span {
    display: flex;
}
</style>